import SceneMarketingResult from './SceneMarketingResult';

export default (props) => {
  return <SceneMarketingResult {...props} />;
};
